import { render, staticRenderFns } from "./LocalizationsTable.vue?vue&type=template&id=7d70bc10"
import script from "./LocalizationsTable.vue?vue&type=script&lang=ts"
export * from "./LocalizationsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports